import {
  faDiagramProject,
  faPerson,
  faRecycle,
  faSparkles,
  faWineGlassCrack,
  faBox,
  faCloud,
  faLock,
  faUnlock,
  faFile,
  faPallet,
  faEnvelope as faEnvelopeLight,
  faBoxTaped,
  faVial,
  faGift,
  faEllipsis,
  faRotateLeft,
  faDollarSign,
  faTruckFast,
} from "@awesome.me/kit-c1b85ff10f/icons/classic/light";
import {
  faEnvelope as faEnvelopeSolid,
  faCircleY,
  faCircleN,
  faTruckFast as faTruckSolid,
} from "@awesome.me/kit-c1b85ff10f/icons/classic/solid";
import { useAppContext } from "../AppProvider";
import timezones from "./timezones.json";
import { faEuro } from "./fontawesomeIcons";

export const useTypes = () => {
  const { dictionary } = useAppContext();

  const collectionStatusList = [
    { value: "DRAFT", label: "Bozza", color: "#c8c6c6" },
    { value: "BOOKED", label: "Prenotato", color: "#a5a3a3" },
    { value: "DELETED", label: "Cancellato", color: "#e51212" },
  ];

  const companies = [
    {
      value: "MASTER_ORGANIZATION",
      label: `Master ${dictionary.registries.organization}`,
      color: "#ff5050",
    },
    {
      value: "ORGANIZATION",
      label: dictionary.registries.organization,
      color: "#ffd075",
    },
    {
      value: "AFILIATE",
      label: dictionary.registries.affiliate,
      color: "#dd9ef9",
    },
    {
      value: "CUSTOMER",
      label: dictionary.registries.customer,
      color: "#75ceff",
    },
    {
      value: "MASTER_ORGANIZATION",
      label: `Master ${dictionary.registries.organization}`,
      color: "#de1600",
    },
  ];

  const currencies = [
    { value: "EUR", label: "€" },
    // { value: "GBR", label: "£" },
    { value: "USD", label: "$" },
  ];

  const currencies2 = [
    { value: "EUR", label: dictionary.currencies.eur, icon: faEuro },
    // { value: "GBR", label: dictionary.currencies.gbr, icon: faSterlingSing },
    { value: "USD", label: dictionary.currencies.usd, icon: faDollarSign },
  ];

  const shipments = [
    {
      value: "EXPRESS",
      label: dictionary.contracts.express,
      color: "#757575",
      icon: faTruckFast,
    },
    {
      value: "EXPRESS_RETURN",
      label: dictionary.contracts.express_return,
      color: "#757575",
      icon: faTruckFast,
    },
    {
      value: "POSTAL",
      label: dictionary.contracts.postal,
      color: "#757575",
      icon: faEnvelopeSolid,
    },
  ];

  const parcels = [
    {
      value: "ENV",
      label: dictionary.parcels.envelope,
      icon: faEnvelopeLight,
    },
    {
      value: "DOC",
      label: dictionary.parcels.document,
      icon: faFile,
    },
    {
      value: "PKG",
      label: dictionary.parcels.package,
      icon: faBoxTaped,
    },
    {
      value: "PAL",
      label: dictionary.parcels.pallet,
      icon: faPallet,
    },
  ];

  const orderStatus = [
    { value: "DRAFT", label: dictionary.status.draft, color: "#C8C6C6" },
    {
      value: "CONFIRMED",
      label: dictionary.status.confirmed_sm,
      color: "#A5A3A3",
    },
    {
      value: "RECEIVED",
      label: `${dictionary.status.received_from_warehouse_sm}`,
      color: "#ff8800",
    },
    {
      value: "CANCELLED",
      label: dictionary.status.cancelled_sm,
      color: "#E51212",
    },
    {
      value: "PROCESSING",
      label: dictionary.status.processing,
      color: "#70AFE2",
    },
    {
      value: "SHIPPED",
      label: dictionary.status.shipped_sm,
      color: "#5DBB85",
    },
    {
      value: "RET_SENDER",
      label: dictionary.status.return_sender,
      color: "#585a60",
    },
    {
      value: "RET_DELIVERED",
      label: dictionary.status.return_delivered,
      color: "#B489C9",
    },
    { value: "ERROR", label: dictionary.status.rejected_sm, color: "#E51212" },
  ];

  const orderTypes = [
    {
      value: "FORWARD",
      label: dictionary.contracts.forward,
    },
    {
      value: "RETURN",
      label: `${dictionary.contracts.express_return}`,
    },
  ];

  const shipmentStatus = [
    {
      value: "DRAFT",
      label: dictionary.status.draft,
      color: "#C8C6C6",
    },
    {
      value: "BOOKED",
      label: dictionary.status.booked_sm,
      color: "#A5A3A3",
    },
    {
      value: "DELETED",
      label: dictionary.status.cancelled_sm,
      color: "#E51212",
    },
    {
      value: "CONFIRMED",
      label: dictionary.status.confirmed_sm,
      color: "#7E7D7D",
    },
    {
      value: "AVAILABLE",
      label: dictionary.status.available_for_collection,
      color: "#EF7414",
    },
    {
      value: "IN_TRANSIT",
      label: dictionary.status.in_transit,
      color: "#70AFE2",
    },
    {
      value: "OUT_OF_DLV",
      label: dictionary.status.out_of_delivery,
      color: "#EFA448",
    },
    {
      value: "EXCEPTION",
      label: dictionary.status.delivery_exception,
      color: "#CB6656",
    },
    {
      value: "FAILED_DLV",
      label: dictionary.status.failed_delivery,
      color: "#B489C9",
    },
    {
      value: "DELIVERED",
      label: dictionary.status.delivered_sm,
      color: "#5DBB85",
    },
    {
      value: "INFO_RCVD",
      label: dictionary.status.infos_received,
      color: "#294978",
    },
    {
      value: "RET_SENDER",
      label: dictionary.status.return_sender,
      color: "#585a60",
    },
    {
      value: "LOST",
      label: dictionary.status.lost_sm,
      color: "#585a60",
    },
    {
      value: "TKN_DLV",
      label: dictionary.status.taking_charge,
      color: "#7E7D7D",
      hidden: true,
    },
    {
      value: "STOCK_RELEASE",
      label: dictionary.shipments.stock_release,
      color: "#000000",
      hidden: true,
    },
    {
      value: "ABANDONED",
      label: `${dictionary.status.abbandoned_sm}/${dictionary.status.destroyed_sm}`,
      color: "#585a60",
    },
  ];

  const confirmationOptions = [
    { value: "true", label: dictionary.words.yes, isBool: false },
    { value: "false", label: dictionary.words.no, isBool: false },
  ];

  const nullableOptions = [
    { value: "NULL", label: dictionary.words.yes },
    { value: "NOT_NULL", label: dictionary.words.no },
  ];

  const booleanOptions = [
    {
      value: "TRUE",
      label: dictionary.words.yes,
      color: "#5DBB85",
      icon: faCircleY,
    },
    {
      value: "FALSE",
      label: dictionary.words.no,
      color: "#ff0000",
      icon: faCircleN,
    },
  ];

  const contractTypes = [
    {
      value: "ACTIVE",
      label: dictionary.words.active,
      color: "#8e70c1",
    },
    {
      value: "PASSIVE",
      label: dictionary.words.passive,
      color: "#ffd648",
    },
  ];

  const confirmationBoolOptions = [
    { value: "true", label: dictionary.words.yes, isBool: true },
    { value: "false", label: dictionary.words.no, isBool: true },
  ];

  const locationLevels = [
    {
      value: "AddressType",
      label: dictionary.locations.address,
      color: "#e6194B",
    },
    {
      value: "StreetType",
      label: dictionary.locations.street,
      color: "#f58231",
    },
    {
      value: "IntersectionType",
      label: dictionary.locations.intersection,
      color: "#ffe119",
    },
    {
      value: "PointOfInterestType",
      label: dictionary.locations.point_of_interest,
      color: "#bfef45",
    },
    {
      value: "CountryType",
      label: dictionary.locations.country,
      color: "#3cb44b",
    },
    {
      value: "RegionType",
      label: dictionary.locations.region,
      color: "#42d4f4",
    },
    {
      value: "SubRegionType",
      label: dictionary.locations.province,
      color: "#4363d8",
    },
    {
      value: "MunicipalityType",
      label: dictionary.locations.city,
      color: "#911eb4",
    },
    {
      value: "NeighborhoodType",
      label: dictionary.locations.district,
      color: "#f032e6",
    },
    {
      value: "PostalCodeType",
      label: dictionary.locations.postal_code,
      color: "#000075",
    },
  ];

  const goods = [
    { value: "NEW", label: dictionary.words.new_sm, icon: faSparkles },
    { value: "USED", label: dictionary.words.used_sm, icon: faRecycle },
    {
      value: "DAMAGED",
      label: dictionary.words.damaged,
      icon: faWineGlassCrack,
    },
  ];

  const ownership = [
    {
      value: "inherited",
      label: dictionary.words.inherited,
      icon: faDiagramProject,
    },
    { value: "own", label: dictionary.words.own_sm, icon: faPerson },
  ];

  const products = [
    {
      value: "PHYSICAL",
      label: dictionary.products.physical_good,
      icon: faBox,
      color: "#7E7D7D",
    },
    {
      value: "DIGITAL",
      label: dictionary.products.digital_good,
      icon: faCloud,
      color: "#70AFE2",
    },
  ];

  const domains = [
    {
      value: "PRIVATE",
      label: dictionary.words.private,
      icon: faLock,
    },
    {
      value: "PUBLIC",
      label: dictionary.words.public,
      icon: faUnlock,
    },
  ];

  const languages = [
    {
      value: "it",
      label: "Italiano",
      logoUrl: "https://www.worldometers.info//img/flags/small/tn_it-flag.gif",
    },
    {
      value: "en",
      label: "English",
      logoUrl: "https://www.worldometers.info//img/flags/small/tn_uk-flag.gif",
    },
    {
      value: "fr",
      label: "Français",
      logoUrl: "https://www.worldometers.info//img/flags/small/tn_fr-flag.gif",
    },
  ];

  const triggers = [
    {
      value: "ORDER_PROCESSED",
      label: dictionary.orders.order_processed,
      color: "#70AFE2",
    },
    {
      value: "SHIPMENT_CREATED",
      label: dictionary.shipments.shipment_created,
      color: "#7E7D7D",
    },
    {
      value: "SHIPMENT_DELIVERY",
      label: dictionary.shipments.shipment_delivery,
      color: "#EFA448",
    },
    {
      value: "SHIPMENT_DELIVERED",
      label: dictionary.shipments.shipment_delivered,
      color: "#5DBB85",
    },
  ];

  const emailEvents = [
    {
      value: "CREATED",
      label: dictionary.status.created_sm,
    },
    {
      value: "SENT",
      label: dictionary.status.sent_sm,
    },
    {
      value: "OPENED",
      label: dictionary.status.opened_sm,
    },
    {
      value: "BOUNCED",
      label: dictionary.status.rejected_sm,
    },
    {
      value: "COMPLAINT",
      label: dictionary.status.complaint_sm,
    },
    {
      value: "CLICKED",
      label: dictionary.status.clicked_sm,
    },
    {
      value: "RECEIVED",
      label: dictionary.status.received_sm,
    },
  ];

  const barcodeMovements = [
    ...orderStatus,
    ...shipmentStatus,
    {
      value: "MOVEMENT",
      label: dictionary.words.movement,
      color: "#ffd075",
    },
  ].filter(
    (item, index, self) =>
      index === self.findIndex((t) => t.value === item.value)
  );

  const suppliers = [
    {
      value: "COMPANY",
      label: dictionary.registries.company,
      color: "#70AFE2",
    },
    {
      value: "INTEGRATION",
      label: dictionary.integrations.integration,
      color: "#7E7D7D",
    },
  ];

  const purchases = [
    {
      value: "SHIPMENT",
      label: dictionary.shipments.shipment,
    },
    {
      value: "PLAN_PURCHASE",
      label: dictionary.integrations.integration,
      color: "#7E7D7D",
    },
  ];

  const customData = [
    {
      value: "COMMERCIAL_SAMPLE",
      label: dictionary.custom_data.commercial_sample,
      icon: faVial,
    },
    {
      value: "COMMERCIAL_PARCEL",
      label: dictionary.custom_data.commercial_parcel,
      icon: faBox,
    },
    { value: "DOCUMENT", label: dictionary.custom_data.document, icon: faFile },
    { value: "GIFT", label: dictionary.custom_data.gift, icon: faGift },
    { value: "OTHER", label: dictionary.custom_data.other, icon: faEllipsis },
    {
      value: "RETURN_OF_GOODS",
      label: dictionary.custom_data.return_of_goods,
      icon: faRotateLeft,
    },
  ];

  const countryIsoCodes2 = [
    { code: "AF", label: "Afghanistan" },
    { code: "AX", label: "Aland Islands" },
    { code: "AL", label: "Albania" },
    { code: "DZ", label: "Algeria" },
    { code: "AS", label: "American Samoa" },
    { code: "AD", label: "Andorra" },
    { code: "AO", label: "Angola" },
    { code: "AI", label: "Anguilla" },
    { code: "AQ", label: "Antarctica" },
    { code: "AG", label: "Antigua And Barbuda" },
    { code: "AR", label: "Argentina" },
    { code: "AM", label: "Armenia" },
    { code: "AW", label: "Aruba" },
    { code: "AU", label: "Australia" },
    { code: "AT", label: "Austria" },
    { code: "AZ", label: "Azerbaijan" },
    { code: "BS", label: "Bahamas" },
    { code: "BH", label: "Bahrain" },
    { code: "BD", label: "Bangladesh" },
    { code: "BB", label: "Barbados" },
    { code: "BY", label: "Belarus" },
    { code: "BE", label: "Belgium" },
    { code: "BZ", label: "Belize" },
    { code: "BJ", label: "Benin" },
    { code: "BM", label: "Bermuda" },
    { code: "BT", label: "Bhutan" },
    { code: "BO", label: "Bolivia" },
    { code: "BA", label: "Bosnia And Herzegovina" },
    { code: "BW", label: "Botswana" },
    { code: "BV", label: "Bouvet Island" },
    { code: "BR", label: "Brazil" },
    { code: "IO", label: "British Indian Ocean Territory" },
    { code: "BN", label: "Brunei Darussalam" },
    { code: "BG", label: "Bulgaria" },
    { code: "BF", label: "Burkina Faso" },
    { code: "BI", label: "Burundi" },
    { code: "KH", label: "Cambodia" },
    { code: "CM", label: "Cameroon" },
    { code: "CA", label: "Canada" },
    { code: "CV", label: "Cape Verde" },
    { code: "KY", label: "Cayman Islands" },
    { code: "CF", label: "Central African Republic" },
    { code: "TD", label: "Chad" },
    { code: "CL", label: "Chile" },
    { code: "CN", label: "China" },
    { code: "CX", label: "Christmas Island" },
    { code: "CC", label: "Cocos (Keeling) Islands" },
    { code: "CO", label: "Colombia" },
    { code: "KM", label: "Comoros" },
    { code: "CG", label: "Congo" },
    { code: "CD", label: "Congo}, Democratic Republic" },
    { code: "CK", label: "Cook Islands" },
    { code: "CR", label: "Costa Rica" },
    { code: "CI", label: "Cote D'Ivoire" },
    { code: "HR", label: "Croatia" },
    { code: "CU", label: "Cuba" },
    { code: "CY", label: "Cyprus" },
    { code: "CZ", label: "Czech Republic" },
    { code: "DK", label: "Denmark" },
    { code: "DJ", label: "Djibouti" },
    { code: "DM", label: "Dominica" },
    { code: "DO", label: "Dominican Republic" },
    { code: "EC", label: "Ecuador" },
    { code: "EG", label: "Egypt" },
    { code: "SV", label: "El Salvador" },
    { code: "GQ", label: "Equatorial Guinea" },
    { code: "ER", label: "Eritrea" },
    { code: "EE", label: "Estonia" },
    { code: "ET", label: "Ethiopia" },
    { code: "FK", label: "Falkland Islands (Malvinas)" },
    { code: "FO", label: "Faroe Islands" },
    { code: "FJ", label: "Fiji" },
    { code: "FI", label: "Finland" },
    { code: "FR", label: "France" },
    { code: "GF", label: "French Guiana" },
    { code: "PF", label: "French Polynesia" },
    { code: "TF", label: "French Southern Territories" },
    { code: "GA", label: "Gabon" },
    { code: "GM", label: "Gambia" },
    { code: "GE", label: "Georgia" },
    { code: "DE", label: "Germany" },
    { code: "GH", label: "Ghana" },
    { code: "GI", label: "Gibraltar" },
    { code: "GR", label: "Greece" },
    { code: "GL", label: "Greenland" },
    { code: "GD", label: "Grenada" },
    { code: "GP", label: "Guadeloupe" },
    { code: "GU", label: "Guam" },
    { code: "GT", label: "Guatemala" },
    { code: "GG", label: "Guernsey" },
    { code: "GN", label: "Guinea" },
    { code: "GW", label: "Guinea-Bissau" },
    { code: "GY", label: "Guyana" },
    { code: "HT", label: "Haiti" },
    { code: "HM", label: "Heard Island & Mcdonald Islands" },
    { code: "VA", label: "Holy See (Vatican City State)" },
    { code: "HN", label: "Honduras" },
    { code: "HK", label: "Hong Kong" },
    { code: "HU", label: "Hungary" },
    { code: "IS", label: "Iceland" },
    { code: "IN", label: "India" },
    { code: "ID", label: "Indonesia" },
    { code: "IR", label: "Iran}, Islamic Republic Of" },
    { code: "IQ", label: "Iraq" },
    { code: "IE", label: "Ireland" },
    { code: "IM", label: "Isle Of Man" },
    { code: "IL", label: "Israel" },
    { code: "IT", label: "Italy" },
    { code: "JM", label: "Jamaica" },
    { code: "JP", label: "Japan" },
    { code: "JE", label: "Jersey" },
    { code: "JO", label: "Jordan" },
    { code: "KZ", label: "Kazakhstan" },
    { code: "KE", label: "Kenya" },
    { code: "KI", label: "Kiribati" },
    { code: "KR", label: "Korea" },
    { code: "KW", label: "Kuwait" },
    { code: "KG", label: "Kyrgyzstan" },
    { code: "LA", label: "Lao Peoples Democratic Republic" },
    { code: "LV", label: "Latvia" },
    { code: "LB", label: "Lebanon" },
    { code: "LS", label: "Lesotho" },
    { code: "LR", label: "Liberia" },
    { code: "LY", label: "Libyan Arab Jamahiriya" },
    { code: "LI", label: "Liechtenstein" },
    { code: "LT", label: "Lithuania" },
    { code: "LU", label: "Luxembourg" },
    { code: "MO", label: "Macao" },
    { code: "MK", label: "Macedonia" },
    { code: "MG", label: "Madagascar" },
    { code: "MW", label: "Malawi" },
    { code: "MY", label: "Malaysia" },
    { code: "MV", label: "Maldives" },
    { code: "ML", label: "Mali" },
    { code: "MT", label: "Malta" },
    { code: "MH", label: "Marshall Islands" },
    { code: "MQ", label: "Martinique" },
    { code: "MR", label: "Mauritania" },
    { code: "MU", label: "Mauritius" },
    { code: "YT", label: "Mayotte" },
    { code: "MX", label: "Mexico" },
    { code: "FM", label: "Micronesia}, Federated States Of" },
    { code: "MD", label: "Moldova" },
    { code: "MC", label: "Monaco" },
    { code: "MN", label: "Mongolia" },
    { code: "ME", label: "Montenegro" },
    { code: "MS", label: "Montserrat" },
    { code: "MA", label: "Morocco" },
    { code: "MZ", label: "Mozambique" },
    { code: "MM", label: "Myanmar" },
    { code: "NA", label: "Namibia" },
    { code: "NR", label: "Nauru" },
    { code: "NP", label: "Nepal" },
    { code: "NL", label: "Netherlands" },
    { code: "AN", label: "Netherlands Antilles" },
    { code: "NC", label: "New Caledonia" },
    { code: "NZ", label: "New Zealand" },
    { code: "NI", label: "Nicaragua" },
    { code: "NE", label: "Niger" },
    { code: "NG", label: "Nigeria" },
    { code: "NU", label: "Niue" },
    { code: "NF", label: "Norfolk Island" },
    { code: "MP", label: "Northern Mariana Islands" },
    { code: "NO", label: "Norway" },
    { code: "OM", label: "Oman" },
    { code: "PK", label: "Pakistan" },
    { code: "PW", label: "Palau" },
    { code: "PS", label: "Palestinian Territory}, Occupied" },
    { code: "PA", label: "Panama" },
    { code: "PG", label: "Papua New Guinea" },
    { code: "PY", label: "Paraguay" },
    { code: "PE", label: "Peru" },
    { code: "PH", label: "Philippines" },
    { code: "PN", label: "Pitcairn" },
    { code: "PL", label: "Poland" },
    { code: "PT", label: "Portugal" },
    { code: "PR", label: "Puerto Rico" },
    { code: "QA", label: "Qatar" },
    { code: "RE", label: "Reunion" },
    { code: "RO", label: "Romania" },
    { code: "RU", label: "Russian Federation" },
    { code: "RW", label: "Rwanda" },
    { code: "BL", label: "Saint Barthelemy" },
    { code: "SH", label: "Saint Helena" },
    { code: "KN", label: "Saint Kitts And Nevis" },
    { code: "LC", label: "Saint Lucia" },
    { code: "MF", label: "Saint Martin" },
    { code: "PM", label: "Saint Pierre And Miquelon" },
    { code: "VC", label: "Saint Vincent And Grenadines" },
    { code: "WS", label: "Samoa" },
    { code: "SM", label: "San Marino" },
    { code: "ST", label: "Sao Tome And Principe" },
    { code: "SA", label: "Saudi Arabia" },
    { code: "SN", label: "Senegal" },
    { code: "RS", label: "Serbia" },
    { code: "SC", label: "Seychelles" },
    { code: "SL", label: "Sierra Leone" },
    { code: "SG", label: "Singapore" },
    { code: "SK", label: "Slovakia" },
    { code: "SI", label: "Slovenia" },
    { code: "SB", label: "Solomon Islands" },
    { code: "SO", label: "Somalia" },
    { code: "ZA", label: "South Africa" },
    { code: "GS", label: "South Georgia And Sandwich Isl." },
    { code: "ES", label: "Spain" },
    { code: "LK", label: "Sri Lanka" },
    { code: "SD", label: "Sudan" },
    { code: "SR", label: "Surilabel" },
    { code: "SJ", label: "Svalbard And Jan Mayen" },
    { code: "SZ", label: "Swaziland" },
    { code: "SE", label: "Sweden" },
    { code: "CH", label: "Switzerland" },
    { code: "SY", label: "Syrian Arab Republic" },
    { code: "TW", label: "Taiwan" },
    { code: "TJ", label: "Tajikistan" },
    { code: "TZ", label: "Tanzania" },
    { code: "TH", label: "Thailand" },
    { code: "TL", label: "Timor-Leste" },
    { code: "TG", label: "Togo" },
    { code: "TK", label: "Tokelau" },
    { code: "TO", label: "Tonga" },
    { code: "TT", label: "Trinidad And Tobago" },
    { code: "TN", label: "Tunisia" },
    { code: "TR", label: "Turkey" },
    { code: "TM", label: "Turkmenistan" },
    { code: "TC", label: "Turks And Caicos Islands" },
    { code: "TV", label: "Tuvalu" },
    { code: "UG", label: "Uganda" },
    { code: "UA", label: "Ukraine" },
    { code: "AE", label: "United Arab Emirates" },
    { code: "GB", label: "United Kingdom" },
    { code: "US", label: "United States" },
    { code: "UM", label: "United States Outlying Islands" },
    { code: "UY", label: "Uruguay" },
    { code: "UZ", label: "Uzbekistan" },
    { code: "VU", label: "Vanuatu" },
    { code: "VE", label: "Venezuela" },
    { code: "VN", label: "Vietnam" },
    { code: "VG", label: "Virgin Islands}, British" },
    { code: "VI", label: "Virgin Islands}, U.S." },
    { code: "WF", label: "Wallis And Futuna" },
    { code: "EH", label: "Western Sahara" },
    { code: "YE", label: "Yemen" },
    { code: "ZM", label: "Zambia" },
    { code: "ZW", label: "Zimbabwe" },
  ];

  return {
    companies,
    currencies,
    currencies2,
    shipments,
    parcels,
    orderStatus,
    orderTypes,
    shipmentStatus,
    confirmationOptions,
    confirmationBoolOptions,
    nullableOptions,
    booleanOptions,
    locationLevels,
    ownership,
    goods,
    products,
    domains,
    languages,
    triggers,
    emailEvents,
    barcodeMovements,
    timezones,
    suppliers,
    purchases,
    customData,
    collectionStatusList,
    contractTypes,
    countryIsoCodes2,
  };
};
